module.exports = __webpack_public_path__ + "static/media/heart-icon.f12f160e.svg";